/* eslint-disable import/no-named-as-default */
import React from 'react';
import {
  Routes, Route, NavLink, useParams, useLocation,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa6';

import styles from './formation-detail.module.scss';
import { useGetFormation } from '../../../hooks/formations';
import Learners from './learners';
import QuizList from './QuizList';

const Details = () => {
  const { t } = useTranslation(['global', 'formations']);
  const { formationId } = useParams();
  const { pathname } = useLocation();
  const {
    data: formation,
  } = useGetFormation(formationId);
  return (
    <div className={styles.detail}>
      <div className={styles.navigation}>
        <NavLink className={styles.backward} to="/formation">
          <FaArrowLeft />
          {t('back', { ns: 'global' })}
        </NavLink>
        <header>
          <div className={styles.title}>
            <h1>{formation?.name}</h1>
          </div>
          <div className={styles.links}>
            <NavLink to={`/formation/detail/${formationId}`}
              className={`${!pathname.includes('/users') ? styles.active : ''}`}
            >
              {t('nav.informations', { ns: 'formations' })}
            </NavLink>
            <NavLink
              to={`/formation/detail/${formationId}/users`}
              className={`${pathname.includes('/users') ? styles.active : ''}`}
            >
            {t('nav.members', { ns: 'formations' })}
            </NavLink>
          </div>
        </header>
      </div>
      <Routes>
        <Route path='/users' element={<Learners />} />
        <Route path='*' element={<QuizList />} />
      </Routes>
    </div>
  );
};

export default Details;
